export const FILTER_TYPES = {
  THEMATICS: 'thematics',
  CRITERIA_KEYS: 'criteriaKeys',
};
